import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox, Form, Input, Select
} from 'antd';
import moment from 'moment-timezone';
import settings from 'settings';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;
const { Option } = Select;
const { TIMEZONE_BLACKLIST } = settings;

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    active, code, name, timezone
  } = dataSource;

  return {
    name: Form.createFormField({ value: name }),
    code: Form.createFormField({ value: code }),
    timezone: Form.createFormField({ value: timezone }),
    active: Form.createFormField({ value: active })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, checkboxFormItemLayout, dataSource, inputFormItemLayout, form
}) => {
  const { getFieldDecorator } = form;
  const {
    active, code, name, timezone
  } = dataSource;
  const readonly = !canAdmin;
  const timezones = moment.tz.names()
    .filter(n => TIMEZONE_BLACKLIST.indexOf(n) === -1);
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Code">
        {
          getFieldDecorator('code', {
            initialValue: code,
            rules: [{
              required: true,
              message: 'Please enter the Location Code.'
            }]
          })(<Input disabled={readonly} maxLength={5} />)
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Name">
        {
          getFieldDecorator('name', {
            initialValue: name,
            rules: [{
              required: true,
              message: 'Please enter the Location Name.'
            }]
          })(<Input disabled={readonly} maxLength={255} />)
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Timezone">
        {
          getFieldDecorator('timezone', {
            initialValue: timezone,
            rules: [{
              required: true,
              message: 'Please select a timezone for this location.'
            }]
          })(
            <Select disabled={readonly} showSearch placeholder="Select Timezone">
              {timezones.map(tz => (
                <Option key={tz}>
                  {tz}
                </Option>
              ))}
            </Select>
          )
        }
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('active', {
            initialValue: active,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Active
            </Checkbox>
          )
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const LocationFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default LocationFormInput;
